import domReady from '@wordpress/dom-ready';
import { scroll } from 'motion/react';

domReady(async () => {
	const selector = 'wp-block-table';
	const tables = document.querySelectorAll(`.${selector}`);

	if (!tables.length) {
		return;
	}

	const delta = 0.05;

	tables.forEach((table) => {
		table.classList.add(`${selector}-scroll-mask`);
		table.parentElement.classList.add(`${selector}-wrapper`);

		scroll(
			(progress, info) => {
				if (info?.x?.scrollLength === 0) {
					table.style.setProperty('--start', 'black');
					table.style.setProperty('--end', 'black');
				} else if (progress <= delta) {
					table.style.setProperty('--start', 'black');
					table.style.setProperty('--end', 'transparent');
				} else if (progress >= 1 - delta) {
					table.style.setProperty('--start', 'transparent');
					table.style.setProperty('--end', 'black');
				} else {
					table.style.setProperty('--start', 'transparent');
					table.style.setProperty('--end', 'transparent');
				}
			},
			{ container: table, axis: 'x' },
		);
	});
});
